import React, { PropTypes } from 'react';
import { Link } from 'react-router';

import { Paper, FlatButton } from 'material-ui';

import UpdateItem from './UpdateItem';

const { bool, node, object } = PropTypes;

const StatItem = ({ items }) => (
  <div>
    { items.length > 0 ?
      items.slice(0, 3).map((connection, key) => {
        if (connection.status === 'pending') {
          return (
            <UpdateItem companyName={connection.name} profileImageUrl={connection.profileImageUrl} key={key} />
          );
        }
      })
    :
    <Paper style={{ padding: '30px', textAlign: 'center', height: '100%' }}>
      No Updates At This Time.
    </Paper>
    }
  </div>
);

StatItem.propTypes = {
  children: node,
  disabled: bool,
  style: object,
};

export default StatItem;



// WEBPACK FOOTER //
// ./src/app/components/dashboard/Updates.jsx